module.exports = __webpack_public_path__ + "static/img/icon-keyboard.27f33747.svg";